import React, { useState } from 'react';
import './MetaPixelDashboard.css';

const MetaPixelDashboard = () => {
  // Realistic dummy data for Meta Pixel standard events
  const [eventData] = useState({
    summary: {
      pageViews: 2847,
      addToCart: 156,
      initiateCheckout: 89,
      addPaymentInfo: 67,
      purchases: 52,
      totalRevenue: 1847520.00,
      averageOrderValue: 35529.23,
      conversionRate: 1.83,
      cartAbandonmentRate: 42.95
    },
    pixelHealth: {
      status: 'active',
      eventsLast24Hours: 428,
      lastEventReceived: '2 minutes ago'
    },
    recentEvents: [
      {
        id: 1,
        eventName: 'Purchase',
        eventTime: '2024-11-23 14:32:15',
        value: 45999,
        currency: 'INR',
        contentName: 'Premium Leather Sofa',
        contentCategory: 'Furniture',
        fbp: 'fb.1.1234567890123.1234567890',
        userAgent: 'Chrome/Windows'
      },
      {
        id: 2,
        eventName: 'AddToCart',
        eventTime: '2024-11-23 14:28:42',
        value: 12499,
        currency: 'INR',
        contentName: 'Designer Table Lamp',
        contentCategory: 'Lighting',
        fbp: 'fb.1.1234567890124.1234567891',
        userAgent: 'Safari/MacOS'
      },
      {
        id: 3,
        eventName: 'InitiateCheckout',
        eventTime: '2024-11-23 14:25:10',
        value: 89150,
        currency: 'INR',
        contentName: 'King Size Bed Frame',
        contentCategory: 'Bedroom',
        fbp: 'fb.1.1234567890125.1234567892',
        userAgent: 'Chrome/Android'
      },
      {
        id: 4,
        eventName: 'AddPaymentInfo',
        eventTime: '2024-11-23 14:20:35',
        value: 34849,
        currency: 'INR',
        contentName: 'Modern Dining Set',
        contentCategory: 'Dining',
        fbp: 'fb.1.1234567890126.1234567893',
        userAgent: 'Chrome/Windows'
      },
      {
        id: 5,
        eventName: 'Purchase',
        eventTime: '2024-11-23 14:15:22',
        value: 67990,
        currency: 'INR',
        contentName: 'L-Shaped Sectional Sofa',
        contentCategory: 'Furniture',
        fbp: 'fb.1.1234567890127.1234567894',
        userAgent: 'Safari/iOS'
      },
      {
        id: 6,
        eventName: 'ViewContent',
        eventTime: '2024-11-23 14:10:50',
        value: 25499,
        currency: 'INR',
        contentName: 'Velvet Accent Chair',
        contentCategory: 'Furniture',
        fbp: 'fb.1.1234567890128.1234567895',
        userAgent: 'Chrome/MacOS'
      },
      {
        id: 7,
        eventName: 'AddToCart',
        eventTime: '2024-11-23 14:05:18',
        value: 18999,
        currency: 'INR',
        contentName: 'Coffee Table - Marble Top',
        contentCategory: 'Living Room',
        fbp: 'fb.1.1234567890129.1234567896',
        userAgent: 'Chrome/Windows'
      },
      {
        id: 8,
        eventName: 'InitiateCheckout',
        eventTime: '2024-11-23 13:58:45',
        value: 43200,
        currency: 'INR',
        contentName: 'Wooden Wardrobe',
        contentCategory: 'Bedroom',
        fbp: 'fb.1.1234567890130.1234567897',
        userAgent: 'Firefox/Windows'
      },
      {
        id: 9,
        eventName: 'AddPaymentInfo',
        eventTime: '2024-11-23 13:52:30',
        value: 29999,
        currency: 'INR',
        contentName: 'Bookshelf Unit - Oak',
        contentCategory: 'Storage',
        fbp: 'fb.1.1234567890131.1234567898',
        userAgent: 'Safari/iOS'
      },
      {
        id: 10,
        eventName: 'Purchase',
        eventTime: '2024-11-23 13:45:12',
        value: 56800,
        currency: 'INR',
        contentName: 'Recliner Sofa Set',
        contentCategory: 'Furniture',
        fbp: 'fb.1.1234567890132.1234567899',
        userAgent: 'Chrome/Android'
      },
      {
        id: 11,
        eventName: 'ViewContent',
        eventTime: '2024-11-23 13:38:22',
        value: 8999,
        currency: 'INR',
        contentName: 'Decorative Wall Mirror',
        contentCategory: 'Decor',
        fbp: 'fb.1.1234567890133.1234567900',
        userAgent: 'Chrome/MacOS'
      },
      {
        id: 12,
        eventName: 'AddToCart',
        eventTime: '2024-11-23 13:30:45',
        value: 15499,
        currency: 'INR',
        contentName: 'Pendant Light Fixture',
        contentCategory: 'Lighting',
        fbp: 'fb.1.1234567890134.1234567901',
        userAgent: 'Safari/MacOS'
      }
    ],
    topProducts: [
      { name: 'Premium Leather Sofa', events: 28, revenue: 1287972, conversions: 8 },
      { name: 'King Size Bed Frame', events: 24, revenue: 534900, conversions: 6 },
      { name: 'L-Shaped Sectional', events: 19, revenue: 1291810, conversions: 19 },
      { name: 'Velvet Accent Chair', events: 15, revenue: 382485, conversions: 15 },
      { name: 'Dining Set Collection', events: 12, revenue: 418188, conversions: 12 }
    ],
    eventConversion: {
      viewContent: { count: 2847, toAddCart: 5.48 },
      addToCart: { count: 156, toCheckout: 57.05 },
      initiateCheckout: { count: 89, toPayment: 75.28 },
      addPaymentInfo: { count: 67, toPurchase: 77.61 }
    }
  });

  const getEventBadgeClass = (eventName) => {
    const eventMap = {
      'Purchase': 'event-badge purchase',
      'AddToCart': 'event-badge add-to-cart',
      'InitiateCheckout': 'event-badge checkout',
      'AddPaymentInfo': 'event-badge payment',
      'ViewContent': 'event-badge view-content',
      'PageView': 'event-badge page-view'
    };
    return eventMap[eventName] || 'event-badge';
  };

  return (
    <div className="meta-pixel-dashboard">
      <div className="dashboard-header">
        <div className="header-content">
          <h1>Meta Pixel Analytics</h1>
          <p className="dashboard-subtitle">Standard E-commerce Events Tracking</p>
        </div>
        <div className="pixel-status">
          <div className={`status-indicator ${eventData.pixelHealth.status}`}></div>
          <div className="status-info">
            <span className="status-label">Pixel Status: Active</span>
            <span className="status-detail">{eventData.pixelHealth.eventsLast24Hours} events in last 24h</span>
          </div>
        </div>
      </div>

      {/* Core Metrics - Meta Pixel Standard Events */}
      <div className="metrics-grid">
        <div className="metric-card">
          <div className="metric-header">
            <span className="metric-label">Page Views</span>
            <span className="metric-icon">👁️</span>
          </div>
          <p className="metric-value">{eventData.summary.pageViews.toLocaleString()}</p>
          <span className="metric-description">Total page views tracked</span>
        </div>

        <div className="metric-card">
          <div className="metric-header">
            <span className="metric-label">Add to Cart</span>
            <span className="metric-icon">🛒</span>
          </div>
          <p className="metric-value">{eventData.summary.addToCart}</p>
          <span className="metric-description">AddToCart events</span>
        </div>

        <div className="metric-card">
          <div className="metric-header">
            <span className="metric-label">Initiate Checkout</span>
            <span className="metric-icon">📝</span>
          </div>
          <p className="metric-value">{eventData.summary.initiateCheckout}</p>
          <span className="metric-description">Checkout initiated</span>
        </div>

        <div className="metric-card">
          <div className="metric-header">
            <span className="metric-label">Add Payment Info</span>
            <span className="metric-icon">💳</span>
          </div>
          <p className="metric-value">{eventData.summary.addPaymentInfo}</p>
          <span className="metric-description">Payment details added</span>
        </div>

        <div className="metric-card highlight">
          <div className="metric-header">
            <span className="metric-label">Purchases</span>
            <span className="metric-icon">✅</span>
          </div>
          <p className="metric-value">{eventData.summary.purchases}</p>
          <span className="metric-description">Completed purchases</span>
        </div>

        <div className="metric-card highlight">
          <div className="metric-header">
            <span className="metric-label">Total Revenue</span>
            <span className="metric-icon">💰</span>
          </div>
          <p className="metric-value">₹{eventData.summary.totalRevenue.toLocaleString('en-IN')}</p>
          <span className="metric-description">Purchase event value</span>
        </div>
      </div>

      {/* Conversion Funnel */}
      <div className="dashboard-section">
        <h2>Conversion Funnel</h2>
        <div className="funnel-container">
          <div className="funnel-stage">
            <div className="stage-info">
              <span className="stage-name">View Content</span>
              <span className="stage-count">{eventData.eventConversion.viewContent.count}</span>
            </div>
            <div className="stage-bar" style={{ width: '100%' }}></div>
            <span className="stage-conversion">{eventData.eventConversion.viewContent.toAddCart}% → Add to Cart</span>
          </div>

          <div className="funnel-stage">
            <div className="stage-info">
              <span className="stage-name">Add to Cart</span>
              <span className="stage-count">{eventData.eventConversion.addToCart.count}</span>
            </div>
            <div className="stage-bar" style={{ width: '75%' }}></div>
            <span className="stage-conversion">{eventData.eventConversion.addToCart.toCheckout}% → Checkout</span>
          </div>

          <div className="funnel-stage">
            <div className="stage-info">
              <span className="stage-name">Initiate Checkout</span>
              <span className="stage-count">{eventData.eventConversion.initiateCheckout.count}</span>
            </div>
            <div className="stage-bar" style={{ width: '55%' }}></div>
            <span className="stage-conversion">{eventData.eventConversion.initiateCheckout.toPayment}% → Payment Info</span>
          </div>

          <div className="funnel-stage">
            <div className="stage-info">
              <span className="stage-name">Add Payment Info</span>
              <span className="stage-count">{eventData.eventConversion.addPaymentInfo.count}</span>
            </div>
            <div className="stage-bar" style={{ width: '40%' }}></div>
            <span className="stage-conversion">{eventData.eventConversion.addPaymentInfo.toPurchase}% → Purchase</span>
          </div>

          <div className="funnel-stage final">
            <div className="stage-info">
              <span className="stage-name">Purchase</span>
              <span className="stage-count">{eventData.summary.purchases}</span>
            </div>
            <div className="stage-bar" style={{ width: '25%' }}></div>
            <span className="stage-conversion">Conversion: {eventData.summary.conversionRate}%</span>
          </div>
        </div>
      </div>

      {/* Top Performing Products */}
      <div className="dashboard-section">
        <h2>Top Products by Events</h2>
        <div className="products-table">
          <table>
            <thead>
              <tr>
                <th>Product Name</th>
                <th>Events Fired</th>
                <th>Revenue</th>
                <th>Conversions</th>
              </tr>
            </thead>
            <tbody>
              {eventData.topProducts.map((product, index) => (
                <tr key={index}>
                  <td className="product-name">{product.name}</td>
                  <td>{product.events}</td>
                  <td className="revenue">₹{product.revenue.toLocaleString('en-IN')}</td>
                  <td className="conversions">{product.conversions}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Recent Events Table */}
      <div className="dashboard-section">
        <h2>Recent Pixel Events</h2>
        <div className="events-table-container">
          <table className="events-table">
            <thead>
              <tr>
                <th>Event Name</th>
                <th>Time</th>
                <th>Content Name</th>
                <th>Category</th>
                <th>Value</th>
                <th>FB Browser ID</th>
              </tr>
            </thead>
            <tbody>
              {eventData.recentEvents.map((event) => (
                <tr key={event.id}>
                  <td>
                    <span className={getEventBadgeClass(event.eventName)}>
                      {event.eventName}
                    </span>
                  </td>
                  <td className="timestamp">{event.eventTime}</td>
                  <td className="content-name">{event.contentName}</td>
                  <td className="category">{event.contentCategory}</td>
                  <td className="value">₹{event.value.toLocaleString('en-IN')}</td>
                  <td className="fbp">{event.fbp.substring(0, 25)}...</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Integration Note */}
      <div className="dashboard-footer">
        <div className="integration-note">
          <strong>📊 Demo Data:</strong> This dashboard displays sample data for demonstration purposes. 
          When integrated with Meta Pixel, it will track real-time e-commerce events including ViewContent, 
          AddToCart, InitiateCheckout, AddPaymentInfo, and Purchase events with actual user data.
        </div>
      </div>
    </div>
  );
};

export default MetaPixelDashboard;
